//
// Module for the Death Setup wizard's Initiate step
//
rs.module("participant/benefit/setup/death/wizard/recalcclaimdetailsstep",

    [
        "controls/components/event-banner"
    ],

    function (eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, basisPlans) {
            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var basisPlanSelect = stepContainer.js(jsSelectors.basisPlanSelect, { required: false });
            var splitPlanCalculationCheckBox = stepContainer.js(jsSelectors.splitPlanCalculationCheckBox, { required: false });

            // Hookup benefitTypeSelect change event
            basisPlanSelect.change(basisPlanChange);

            // Basis Plan change event
            function basisPlanChange() {
                var selectedBasisPlanKey = basisPlanSelect.val();

                if (!selectedBasisPlanKey || !basisPlans) {
                    splitPlanCalculationCheckBox.setChecked(false).clearErrors();
                    return;
                }

                // Find the selected basis plan
                var selectedPlan = basisPlans.find(function (plan) {
                    return plan.PlanKey == selectedBasisPlanKey;
                });

                if (selectedPlan) {
                    // Set checkbox based on SplitPlanFlag
                    splitPlanCalculationCheckBox.setChecked(selectedPlan.SplitPlanFlag === true).clearErrors();
                } else {
                    splitPlanCalculationCheckBox.setChecked(false).clearErrors();
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);